import {Typography, alpha} from '@mui/material'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import {grey, purple} from '@mui/material/colors'
import React from 'react'
type Props = {
  filterList: Record<string, any>
  handleDelete: (filterKey: string, setStateAction: any) => void
  handleStateAction?: React.Dispatch<
    React.SetStateAction<{type: string; filters: Record<string, any>}[]>
  >
  universities?: {key: any; value: any}[]
}

export default function FilterListPills({
  filterList,
  handleDelete,
  handleStateAction,
  universities,
}: Props): React.ReactElement {
  return (
    <Typography variant='caption'>
      <Box display={'flex'}>
        <Stack direction={'row'} spacing={1} flexWrap={'wrap'}>
          {Object.entries(filterList)?.map(([k, v], i) => {
            return (
              <Box display={'inline-flex'} key={`oe_${i}`}>
                <Chip
                  key={i}
                  onDelete={() => handleDelete(k, handleStateAction)}
                  label={
                    // value is boolean string or number, if boolean then 'on'
                    <span>
                      {v.display} -{' '}
                      {typeof v.value === 'string'
                        ? v.value
                        : typeof v.value === 'number'
                        ? v.value
                        : Array.isArray(v.value) && k === 'multi_university' && universities
                        ? v.value.map(
                            (key: any, i: any) =>
                              (universities.find((f) => f.key === key)?.value ?? '') +
                              (i != v.value.length - 1 ? ' | ' : '')
                          )
                        : typeof v.value === 'object'
                        ? Object.values(v.value)[0]
                        : 'on'}
                    </span>
                  }
                  sx={{
                    mt: 0.5,
                    mb: 0.5,
                    bgcolor: alpha(purple[700], 0.8),
                    '& .MuiChip-deleteIcon': {
                      color: grey[50],
                      fontSize: '1.3rem',
                    },
                    '& .MuiChip-deleteIcon:hover': {
                      color: grey[400],
                    },
                    '& .MuiChip-label': {
                      fontSize: '1rem',
                      color: 'white',
                    },
                  }}
                />
              </Box>
            )
          })}
        </Stack>
      </Box>
    </Typography>
  )
}
